<template>
  <div class="animated fadeIn inventory-in">
    <b-card>
      <div slot="header">Inventory IN (Receipt) 
        <div class="card-header-actions">
          <!-- <b-button variant="btn btn-primary mr-1" @click="add">IN from Receiving PO</b-button>
          <b-button variant="btn btn-primary mr-1" @click="addOther">IN from Others</b-button>
          <b-button variant="btn btn-primary mr-1" @click="addMediaLepas">Media Display Dilepas</b-button> -->
          <b-dropdown right text="Add" variant="primary" class="mr-1">
            <b-dropdown-item @click="add">IN from Receiving PO</b-dropdown-item>
            <b-dropdown-item @click="addMediaLepas">IN from "Pelepasan Media Display"</b-dropdown-item>
            <b-dropdown-item @click="addOther">IN from Others</b-dropdown-item>
          </b-dropdown>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="print()">
              <i class="fa fa-print"></i> Print
          </button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="togleFilter()">
            <i class="fa fa-filter"></i> Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-row>
                <b-col lg="9" >
                <b-input-group>
                    <b-input-group-prepend><label>Receiving Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" placeholder="from date"></b-form-input>
                    <b-input-group-append><span class="input-group-text">-</span></b-input-group-append>
                    <b-form-input v-model="tblData.tgl2" type="date" placeholder="until date"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="3">                            
                <b-input-group>
                    <b-input-group-prepend><label style="width:90px;">Available Qty</label></b-input-group-prepend>
                      <b-form-select v-model="tblData.outstand" :plain="true" :options="dataList.openStatus"></b-form-select>
                </b-input-group>
                </b-col>
            </b-row>    
            <b-row no-gutters>
                <b-col lg="7" >
                <b-input-group>
                    <b-input-group-prepend><label>Item Code/Name</label></b-input-group-prepend>
                    <!-- <b-form-input v-model="tblData.partnumber" placeholder="Item Code/Number/Name"></b-form-input> -->
                    <b-form-input v-model="tblData.itemname" placeholder="Item Name" @change="itemChange"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="lkuItemShow=true" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
                </b-col>
                <b-col lg="5">                            
                <b-input-group>
                    <b-input-group-prepend><label class="text-right">Store/Warehouse</label></b-input-group-prepend>
                      <b-form-select v-model="tblData.idStore" :plain="true" :options="dataList.warehouse"></b-form-select>
                </b-input-group>
                </b-col>
            </b-row>    
            <b-row no-gutters>
                <b-col lg="7" >
                  <b-input-group>
                      <b-input-group-prepend><label>Inventory Category</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.nmcategory" placeholder="Category"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCategoryShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                  </b-input-group>
                </b-col>
                <b-col lg="5">                            
                  <!-- <b-input-group>
                      <b-input-group-prepend><label>Head Category</label></b-input-group-prepend>
                        <b-form-input v-model="tblData.inven_catid" placeholder="Head Category"></b-form-input>
                  </b-input-group> -->
                  <b-input-group>
                      <b-input-group-append><span class="p-2">S/N</span></b-input-group-append>
                      <b-form-input v-model="tblData.serialNum" placeholder="Serial Number"></b-form-input>
                      <b-input-group-append><span class="p-2">Barang Barter</span></b-input-group-append>
                      <b-form-select v-model="tblData.barangbarter" :plain="true" :options="dataList.YesNoAll"></b-form-select>
                      <!-- <b-form-checkbox  class="ml-2 mt-2" v-model="tblData.barangbarter" value=1 unchecked-value=0>Barang Barter</b-form-checkbox> -->
                  </b-input-group>
                </b-col>
            </b-row>    
        </b-col>
        <b-col lg="6">
            <b-input-group>
                <b-input-group-prepend><label>Purchase Order#</label></b-input-group-prepend>
                <b-form-input v-model="tblData.purcOrderNo" placeholder="PO Number"></b-form-input>
                <b-input-group-append><span class="input-group-text">-</span></b-input-group-append>
                <b-form-input v-model="tblData.vendorinfo" placeholder="Supplier Name"></b-form-input>
            </b-input-group>
            <b-input-group>
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-append><span class="input-group-text">-</span></b-input-group-append>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value" class="ml-1"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuDimShow=true">
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group>
            <b-input-group>
                <b-input-group-prepend><label>Used items (Bekas)</label></b-input-group-prepend>
                <b-form-select v-model="tblData.barangbekas" :plain="true" :options="dataList.YesNoAll"></b-form-select>
                <b-input-group-append><span class="pt-2 pl-2">Broken(Rusak) &nbsp;</span></b-input-group-append>
                <b-form-select v-model="tblData.barangrusak" :plain="true" :options="dataList.YesNoAll"></b-form-select>
                <b-input-group-append>
                  <b-button class="btn btn-success ml-1 mr-1" @click="search()" size="sm"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button class="btn btn-secondary" @click="clearFilter()" size="sm"> <i class="fa fa-eraser"></i>Clear Filter</b-button>
                </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
        show-empty
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;" >Edit</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;" > Delete</b-dropdown-item>
        </b-dropdown>
      </template>        
        <template v-slot:cell(itemname)="data">
          {{ data.item.itemname }}
          <p v-if="(data.item.fixAsetid)" class="text-muted mb-0 mt-1"> No Aset: {{data.item.fixAsetid}}</p>
        </template>

        <template v-slot:cell(recivDate)="data">
          {{ data.item.recivDate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(expirDate)="data">
          <span v-if="(data.item.expirDate)">{{data.item.expirDate|moment("DD MMM YYYY")}}</span>
        </template>
        <template v-slot:cell(invUnitCost)="data">
          {{data.item.invUnitCost|numFormat}}
        </template>
        <template v-slot:cell(nmcategory)="data">
          {{data.item.kodeacc}} | {{data.item.nmcategory}}
          <p class="mb-0" v-if="(data.item.barangbarter==1)">, ITEMBARTER</p>
          <p class="mb-0" v-if="(data.item.barangbekas==1)">, BARANG BEKAS</p>
          <p class="mb-0" v-if="(data.item.barangrusak==1)">, KONDISI RUSAK</p>
        </template>
        <template v-slot:cell(quantity)="data">
          {{data.item.quantity}} &nbsp; {{data.item.invunitom}}
        </template>
        <template v-slot:cell(qtyAvail)="data">
          {{data.item.qtyAvail}} &nbsp; {{data.item.invunitom}}
        </template>
        <template v-slot:cell(qtyTransfer)="data">
          <span v-if="(data.item.qtyTransfer!=0)">
          {{data.item.qtyTransfer}} &nbsp; {{data.item.invunitom}}</span>
        </template>
        <!-- <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template> -->
        
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>        
        <b-col cols="4">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item Inventory" :centered="true">
            <lku-item @click="onSelectLkuItem"  jasa="0" isactive="1" :formdata="itemList" ></lku-item>
        </b-modal>        
        <b-modal v-model="lkuDimShow" size="lg" :hide-footer="true" title="List of Dimension Value" :centered="true" >
            <lku-dim @click="onSelectedDim" :DimColName="tblData.DimCol" :key="tblData.DimCol"></lku-dim>
        </b-modal>        

        <b-modal v-model="lkuCategoryShow" size="lg" :hide-footer="true" title="Inventory Group/Category" :centered="true" :lazy="true">
            <lku-inventorycategory @click="onSelectLkuCategory" ></lku-inventorycategory>
        </b-modal>        

  </div>
</template>


<style lang="scss">
  .inventory-in {
    table {
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
 }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
      .input-group {
          .input-group-prepend {
              label {
                  width: 110px !important;
              }
          }
      }

    }
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import lkuItem from "../lookup/lkuItemLazzy";
import lkuDim from "../lookup/lkuDim";
import lkuInventorycategory from "../lookup/lkuInventorycategory";
import inv from "../../apis/logistic_inv_in";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: {Loading,lkuItem,lkuDim,lkuInventorycategory},
  data() {
    return {
      lkuItemShow:false,
      itemList:{},
      lkuDimShow:false,

      showFilter: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      lkuCategoryShow:false,
      horizontal: true,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model:{},
        items: [],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        // tgl1:this.$store.state.user.tglaktif,
        // tgl2:this.$store.state.user.akhirbln,
        sortBy: 'itemname',
        sortDesc: true,
        DimCol:'Dim1',outstand:'1'
      },
      pagination: false,
      dataList: {
        openStatus: dropdown.ostandStatus,
        YesNoAll: dropdown.YesNoAll,
        warehouse:[],
      },      

    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thClass: "text-center",
          tdClass: "text-center",
            thStyle: "width:50px",
        },
          {
            key: "recivDate",
            thStyle: "width:90px",
            label: "Receiving Date",
            sortable: true
          },
          {
            key: "partnumber",
            thStyle: "width:100px",
            label: "Item Code",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            thStyle: "width:300px",
            sortable: true
          },
          {
            key: "typeseries",
            label: "Type/ series",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "serialNum",
            label: "Serial Number",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "expirDate",
            label: "Expired",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "invUnitCost",
            label: "Unit Price",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "quantity",
            label: "Qty. Received",
            thStyle: "width:100px",
          },
          {
            key: "qtyAvail",
            label: "Qty. Available",
            thStyle: "width:100px",
          },
          {
            key: "qtyTransfer",
            label: "On Transfer",
            thStyle: "width:100px",
          },
          // {
          //   key: "itemcategory",
          //   label: "Item Category",
          //   thStyle: "width:130px",
          //   sortable: true
          // },
          {
            key: "nmcategory",
            label: "Inventory Group/Cat.",
            thStyle: "width:500px",
            sortable: true
          },
          {
            key: "namaStore",
            thStyle: "width:150px",
            label: "Store/ warehouse",
            sortable: true
          },
          {
            key: "shelfNo",
            label: "Rack/ Shelf",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "purcOrderNo",
            label: "Purchase Order#",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Supplier",
            sortable: true
          },          
        ];
        // const dims = this.$store.state.dimension;
        // for (let i = 0; i < dims.length; i += 1) {
        //   fields.push(          {
        //     key: `${dims[i].value}Txt`,
        //     // thStyle: "width:100px",
        //     label: dims[i].text
        //   },)
        // }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
  created: async function(){
      this.dataList.warehouse = await inv.store(); 
  },  
  methods: {
    onSelectLkuCategory(_selected) {
            this.tblData.inven_catid = _selected.inven_catid;
            this.tblData.nmcategory = _selected.namaacc;
        this.lkuCategoryShow=false;
    },
    onSelectLkuItem: function (lkuData) {
        this.itemList=lkuData;
        this.lkuItemShow=false;

        this.tblData.itemno = lkuData.selected.itemno;
        this.tblData.itemname = lkuData.selected.itemname;
    },
    onSelectedDim: function(_selected){
        // this.tblData.DimVal=_selected.kode;
        // this.tblData.DimValInfo=`${_selected.kode.trim()} | ${_selected.nama}`;
        this.tblData.DimVal=`${_selected.nama.trim()}`;
        this.lkuDimShow=false;
    },

    itemChange: function () {
        this.tblData.itemno = '';
    },

    // onFiltered(filteredItems) {
    //   this.tblData.total = filteredItems.length;
    // },
   data: async function() {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.InvInList) {
            this.tblData[key] = filter.InvInList[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.InvInList.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.InvInList;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await inv.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await inv.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },    
    search() {
      this.tblData.page=1;
      this.$refs.table.refresh();
    },
    refresh() {
      this.$refs.table.refresh();
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','itemno','itemname', 'partnumber', 'serialNum', 'idStore', 'nmcategory','typeseries','inven_catid', 'purcOrderNo', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal', 'vendorinfo', 'gcifNo', 'outstand', 'barangbekas', 'barangrusak', 'barangbarter'];
      let filtered = false;
      const InvInList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              InvInList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          const filter = this.$store.state.filter;
          filter.InvInList = filter.InvInList || {};
          if (!(filter.InvInList.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          InvInList.page=this.tblData.page;
          InvInList.limit=this.tblData.limit;
          InvInList.sortBy=this.tblData.sortBy;
          InvInList.sortDesc=this.tblData.sortDesc;
          filter.InvInList=InvInList;
          this.$store.commit("filter", filter);
      }
    },
    clearFilter() {
        this.tblData.gcifNo= '';
        this.tblData.partnumber=  '';
        this.tblData.serialNum='';
        this.tblData.itemno=  '';
        this.tblData.itemname=  '';
        this.tblData.purcOrderNo=  '';
        this.tblData.vendorinfo=  '';
        this.tblData.nmcategory='',
        this.tblData.inven_catid=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  ''; 
        this.tblData.outstand=  '';
        this.tblData.idStore=  '';
        this.tblData.barangbekas='';
        this.tblData.barangbarter='';
        this.tblData.barangrusak='';
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    add(){
      this.saveFilter();
      router.push({name :"logistic.inv_in_purchase"});
    },
    addOther(){
      this.saveFilter();
      router.push({name :"logistic.inv_in_other"});
    },
    addMediaLepas(){
      this.saveFilter();
      router.push({name :"logistic.inv_in_media_dilepas"});
    },
    rowEdit(record) {
      this.rowClicked(record);
      this.edit();
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },

    edit: function() {
        if (this.model.itemReciKey) {
          this.saveFilter();
          router.push({name :'logistic.inv_in_revision', params: { itemReciKey: this.model.itemReciKey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.itemReciKey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await inv.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.itemReciKey==this.model.itemReciKey));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },

    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    posting: async function () {
        if (this.model.itemReciKey) {
            if ((this.model.posting || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.model.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
            await inv.posting(this.model);
            this.model.posting=1;
            this.print();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await inv.postingUndo(this.model);
            this.model.posting=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    print: async function()
    {
      if (this.model.itemReciKey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await inv.poReceivePrint(this.model);
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await inv.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("/logistic/home");
    },    
  }
};
</script>
